import suniti from "./assets/newTeam/suniti.png";
import vidish from "./assets/newTeam/vidish.png";
import anubha from "./assets/newTeam/anubha.png";
import soumya from "./assets/newTeam/soumya.png";
import abhilasha from "./assets/newTeam/abhilasha.png";
import mamatha from "./assets/newTeam/mamatha.png";
import tanu from "./assets/newTeam/tanu.png";
import ritika from "./assets/newTeam/ritika.png";
import vijay from "./assets/newTeam/vijay.png";
import madhurima from "./assets/newTeam/madhurima.png";
import vishali from "./assets/newTeam/vishali.png";
import bhavya from "./assets/newTeam/bhavya.png";
import mriganshi from "./assets/newTeam/mriganshi.png";
import komal from "./assets/newTeam/komal.png";
import deevesha from "./assets/newTeam/deevesha.png";
import abhishek from "./assets/newTeam/abhishek.png";
import gokul from "./assets/newTeam/gokul.png";
import caique from "./assets/newTeam/caique.png";
import kathambari from "./assets/newTeam/kathambari.png";
import parvathy from "./assets/newTeam/parvathy.png";
import neeharika from "./assets/newTeam/neeharika.png";
import harshitha from "./assets/newTeam/harshitha.png";
import sujith from "./assets/newTeam/sujith.png";
import lakshmi from "./assets/newTeam/lakshmi.png";
import shubhankar from "./assets/newTeam/shubhankar.png";
import ramkala from "./assets/newTeam/ramkala.png";
import deena from "./assets/newTeam/deena.png";
import sadashiv from "./assets/newTeam/sadashiv.png";
import marry_prasanna from "./assets/newTeam/mary.png";
import shahid from "./assets/newTeam/shahid.png";
import scott from "./assets/newTeam/scott.png";
import ramya from "./assets/newTeam/ramya.png"
import saurabh from "./assets/newTeam/saurabh.png"
import franklin from "./assets/newTeam/franklin.png"
import sureshNakka from "./assets/newTeam/sureshNakka.png"
import kushal from "./assets/newTeam/kushal.png"
import jagadeesh from "./assets/newTeam/jagadeesh.png"
import vishnu from "./assets/newTeam/vishnu.png"
import nisar from "./assets/newTeam/nisar.png"
import suresh from "./assets/newTeam/suresh.png"
import ambarish from "./assets/newTeam/ambarish.png"
import suhel from "./assets/newTeam/suhel.png";
import vivek from "./assets/newTeam/vivek.png"
const contactUser = [
  {
    email: "Suniti.Satnalika@unilever.com",
    img: suniti,
    name: "Suniti Satnalika",
  },
  {
    email: "Vidish.Verma@unilever.com",
    img: vidish,
    name: "Vidish Verma",
  },
  {
    email: "Anubha.Aggarwal@unilever.com",
    img: anubha,
    name: "Anubha Aggarwal",
  },
  {
    email: "Soumya.Mohanty@unilever.com",
    img: soumya,
    name: "Soumya Mohanty",
  },
  {
    email: "md.suhel@unilever.com",
    img: suhel,
    name: "Suhel Md",
  },
  { email:"vivek.sagar@unilever.com",
    img:vivek,
    name:"Vivek Sagar"
  },
  {
    email: "Mamatha.Raju@unilever.com",
    img: mamatha,
    name: "Mamatha Raju",
  },
  {
    email: "Tanu.Gupta2@unilever.com",
    img: tanu,
    name: "Tanu Gupta",
  },
  {
    email: "Ritika.Kaushik@unilever.com",
    img: ritika,
    name: "Ritika Kaushik",
  },
  {
    email: "Md.Shahid@unilever.com",
    img: shahid,
    name: "Shahid Md",
  },
  {
    email: "Scott.J.Johnson@unilever.com",
    img: scott,
    name: "Scott J Johnson",
  },
  {
    email: "vijay.reddy@unilever.com",
    img: vijay,
    name: "Vijay Reddy",
  },
   {
    email: "Abhilasha.Sinha@unilever.com",
    img: abhilasha,
    name: "Abhilasha Sinha",
  },
  {
    email: "Madhurima.Jaggi@unilever.com",
    img: madhurima,
    name: "Madhurima Jaggi",
  },
  {
    email: "Vishali.Sharma@unilever.com",
    img: vishali,
    name: "Vishali Sharma",
  },
  {
    email: "Bhavya.Sajnani@unilever.com",
    img: bhavya,
    name: "Bhavya Sajnani",
  },
  {
    email: "Mriganshi.Sharma@unilever.com",
    img: mriganshi,
    name: "Mriganshi Sharma",
  },
  {
    email: "Komal.Falodiya@unilever.com",
    img: komal,
    name: "Komal Falodiya",
  },
  {
    email: "deevesha.sharma@unilever.com",
    img: deevesha,
    name: "Deevesha Sharma",
  },
  {
    email: "abhishek.u@unilever.com",
    img: abhishek,
    name: "Abhishek U",
  },
  {
    email: "Gokul.Sreenivas@unilever.com",
    img: gokul,
    name: "Gokul Sreenivas",
  },
  {
    email: "Caique.Amaral@unilever.com",
    img: caique,
    name: "Caique Amaral",
  },
  {
    email: "Kathambari.KK@unilever.com",
    img: kathambari,
    name: "Kathambari KK",
  },
  {
    email: "Parvathy.TR@unilever.com",
    img: parvathy,
    name: "Parvathy TR",
  },
  {
    email: "Neeharika.Peri@unilever.com",
    img: neeharika,
    name: "Neeharika Peri",
  },
  {
    email: "Harshitha.Tirupati@unilever.com",
    img: harshitha,
    name: "Harshitha Tirupati",
  },
  {
    email: "Ramya.Karunakaran@unilever.com",
    img: ramya,
    name: "Ramya Karunakaran",
  },
  {
    email: "Sujith.Kumar@unilever.com",
    img: sujith,
    name: "Sujith Kumar",
  },
  {
    email: "V.Lakshmi@unilever.com",
    img: lakshmi,
    name: "Lakshmi V",
  },
  {
    email: "Shubhankar.Das@unilever.com",
    img: shubhankar,
    name: "Shubhankar Das",
  },
  {
    email: "Ramkala.Giri@unilever.com",
    img: ramkala,
    name: "Ramkala Giri",
  },
  {
    email: "Deena.Joel@unilever.com",
    img: deena,
    name: "Deena Joel",
  },
  {
    email: "Sadashiv.Kanalae@unilever.com",
    img: sadashiv,
    name: "Sadashiv Kanalae",
  },
  {
    email: "Mary-Prasanna.Lawrence-Dorai@unilever.com",
    img: marry_prasanna,
    name: "Mary-Prasanna",
  },
  {
  email: "Franklin.Dsouza@unilever.com",
  img: franklin,
  name: "Franklin Dsouza",
},
{
  email: "Saurabh.Priyadarshi@unilever.com",
  img: saurabh,
  name: "Saurabh Priyadarshi",
},
{
  email: "suresh.nakka@unilever.com",
  img: sureshNakka,
  name: "Suresh Nakka",
},
{
  email: "Kushal.Jha@unilever.com",
  img: kushal,
  name: "Kushal Jha",
},

{
  email: "Vishnu.Reddy@unilever.com",
  img: vishnu,
  name: "Vishnu Reddy",
},
{
  email: "Nisar.Khan@unilever.com",
  img: nisar,
  name: "Nisar Khan",
},
{
  email: "Gudditi.Suresh@unilever.com",
  img: suresh,
  name: "Suresh Gudditi",
},
{
  email: "Ambarish.Mishra@unilever.com",
  img: ambarish,
  name: "Ambarish Mishra",
}
];
export default contactUser;


